import React from 'react';
import css from './css.module.less';
import { Field, Form } from 'src/components/RcForm';
import { useLayers } from './tools';
import {
  ModalContent,
  //SectionContainer as Section,
} from 'src/components/Layouts';
import { ModalFooter } from 'src/components/Antd';
import { LayerProps } from '@/src/strategies/render/layer';
import { imageCarouselModal } from '@/src/constrains/SalesChannelContent-Revamp/Modules/ImageCarousel';
import layerComponent from '@/src/constrains/SalesChannelContent-Revamp/Layer';

const ImageAndPosterEditModalBody = (props) => {
  const {
    data,
    onConfirm,
    onCancel,
    modalRenderer,
    hoverEffectOptions,
    animationOptions,
    breakpoint,
    buttons,
    validators,
  } = props;
  const [editForm] = Form.useForm();
  const [layerForm] = Form.useForm();
  const {
    handleOnLayerClick,
    handleOnLayerAdd,
    handleOnLayerReorder,
    handleOnLayerDelete,
    handleOnConfirm,
    selectedLayer,
  } = useLayers({
    editForm,
    layerForm,
    data,
    onConfirm,
    breakpoint,
  });
  const template = modalRenderer();
  const left = template?.left || [];

  return (
    <React.Fragment>
      <ModalContent
        style={{
          background: '#f4f5f7',
          marginTop: -32,
          minHeight: 520,
          maxHeight: 'none',
          flex: 1,
        }}>
        <div className={css.wrapper}>
          <Form form={editForm} className={css.left}>
            <div className={css.col}>
              {left.map((i: LayerProps) => {
                return imageCarouselModal(i, {
                  onClick: handleOnLayerClick,
                  onAdd: handleOnLayerAdd,
                  onReorder: handleOnLayerReorder,
                  onDelete: handleOnLayerDelete,
                  validators,
                  breakpoint,
                  editForm,
                  layerForm,
                  selectedLayer,
                });
              })}
            </div>
          </Form>
          <Form form={layerForm} className={css.right}>
            <Field shouldUpdate>
              {(props, meta, { getFieldsValue }) => {
                const layerValue = getFieldsValue(true);
                const layerTemplate = modalRenderer(layerValue);
                const params = {
                  left: layerTemplate?.middle || [],
                  right: layerTemplate?.right || [],
                };
                const comps = layerComponent(params, {
                  buttons,
                  breakpoint,
                  hoverEffectOptions,
                  animationOptions,
                });
                return (
                  <>
                    <div className={css.col}>{comps.left}</div>
                    <div className={css.col}>{comps.right}</div>
                  </>
                );
              }}
            </Field>
          </Form>
        </div>
      </ModalContent>
      <ModalFooter onCancel={onCancel} onOk={handleOnConfirm} />
    </React.Fragment>
  );
};
export default ImageAndPosterEditModalBody;
